<template lang="pug">
  .minimum-weight
    p Required minimum weight remaining
    h2 {{weight}}lbs
    .progress-bar
      .marker(v-for="marker in markers")
      .progress(:style='{width: percentage }')
</template>
<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  minimumWeight: number,
  addedWeight: number,
}>()

const percentage = computed(() => `${(props.addedWeight / props.minimumWeight) * 100}%`)
const weight = computed(() => props.minimumWeight - props.addedWeight)
const markers = computed(() => new Array((props.minimumWeight / 50) - 1))
</script>
<style lang="scss" scoped>
  .minimum-weight{
    margin: $size-m 0;
    p {
      font-size: 14px;
    }
  }
  .progress-bar {
    height: 12px;
    background: $color-gray;
    display: flex;
    justify-content: space-evenly;
    position: relative;
    .marker {
      width: 1px;
      background: $color-black;
    }
    .progress {
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      background: $color-green-light;
      transition: width 200ms ease;
    }
  }
</style>
